import alert from './alert'
import constant from './constant'
import date from './date'
import file from './file'
import loading from './loading'
import telefone from './telefone'
import fonteFinanciamentoFiltros from './fonteFinanciamentoFiltros'
import projetoFiltros from './projetoFiltros'
import colunas from './colunas'

export default {
    install(Vue) {
        Vue.mixin(alert)
        Vue.mixin(constant)
        Vue.mixin(date)
        Vue.mixin(file)
        Vue.mixin(loading)
        Vue.mixin(telefone)
        Vue.mixin(fonteFinanciamentoFiltros)
        Vue.mixin(projetoFiltros)
        Vue.mixin(colunas)
    }
}
